import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import React, { Component } from 'react';

import { customFetchV2 } from '../../../services/custom-fetch-v2.ts';
import SubmitButton from '../../SubmitButton.jsx';
import AudioPackSelector from './AudioPackSelector.jsx';

class PurchaseAudioMinutesRoute extends Component {
  state = {
    isLoading: false,
    purchaseCompleted: false,
    availablePacks: [
      {
        id: '2-hours-b',
        title: '$6',
        subtitle: '2 hours',
        disabled: false,
      },
      {
        id: '5-hours-b',
        title: '$12',
        subtitle: '5 hours',
        banner: 'Most Popular',
        disabled: false,
      },
      {
        id: '12-hours-b',
        title: '$25',
        subtitle: '12 hours',
        banner: 'Best Value',
        disabled: true,
      },
    ],
    selectedPackId: '2-hours-b',
  }

  handlePackSelect = (pack) => {
    this.setState({
      selectedPackId: pack.id,
    });
  }

  renderContent() {
    if (this.state.purchaseCompleted) {
      return PurchaseAudioMinutesRoute.renderCompleted();
    }

    return this.renderPurchaseForm();
  }

  static renderCompleted() {
    return (
      <div>
        <h5 className="title is-5">
          <span className="icon has-text-success is-large">
            <i className="fa fa-check-circle fa-2x"></i>
          </span>
          Payment success
        </h5>
        <p className="spaced-content disclaimer">
          Your payment was successful and minutes have been credited to your account.
        </p>
      </div>
    );
  }

  renderPurchaseForm() {
    const selectedPack = this.getSelectedPack();
    return (
      <div>
        {this.renderErrorBox()}
        <p className="disclaimer">
          Purchase pay as you go minutes to listen in on your tracker.
        </p>
        <AudioPackSelector
          packs={this.state.availablePacks}
          selectedPackId={this.state.selectedPackId}
          onPackSelect={this.handlePackSelect}
        />
        <div className="login__messageBox">
        <WarningRoundedIcon className="login__messageBox__icon" fontSize="large" style={{ marginRight: '10px' }} />
          We will be discontinuing our live audio service on December 1st, 2021.
          Please note that calls made to your device after this date will no longer connect.
          We apologise for the inconvenience.
      </div>
        <form className="spaced-content" onSubmit={this.handleSubmit}>
          <SubmitButton
            label={`Pay ${selectedPack.title}`}
            className="button is-primary is-medium is-fullwidth"
            disabled={this.state.isLoading}
            loading={this.state.isLoading}
          />
        </form>
      </div>
    );
  }

  getSelectedPack = () => this.state.availablePacks.find(
    pack => pack.id === this.state.selectedPackId,
  );

  renderErrorBox = () => {
    if (this.state.errorMessage) {
      return (
        <div className="notification is-danger">
          {this.state.errorMessage}
        </div>
      );
    }

    return false;
  }

  handleSubmit = (evt) => {
    evt.preventDefault();

    this.setState({
      isLoading: true,
      errorMessage: '',
    });

    this.makePurchase(this.state.selectedPackId)
      .then(() => {
        this.setState({
          isLoading: false,
          purchaseCompleted: true,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          errorMessage: error.message,
        });
      });
  }

  makePurchase = (packTag) => {
    const deviceId = this.props.match.params.id;

    return customFetchV2(`/api/devices/${deviceId}/purchase-audio-time-pack`, {
      method: 'POST',
      body: JSON.stringify({
        pack_tag: packTag,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Unable to complete purchase.');
        }

        return response.data;
      })
      .then((json) => {
        if (!json.success) {
          throw new Error(json.errorMessage);
        }
      });
  }

  render() {
    return (
      <React.Fragment>
        <div className="section">
          {this.renderContent()}
        </div>
      </React.Fragment>
    );
  }
}

export default PurchaseAudioMinutesRoute;
